<template>

	<hit_login>

		<div class="hit-html-html" >
		<div class="hit-row">

			<div class="hit-col-md-12">
				<div class="hit-form-group">
					<div class="hit-row">

						<div class="hit-col-md-4">
							<div class="hit-panel hit-panel-warning">

								<div class="hit-panel-body hit-text-center hit-text-warning">

									<div class="hit-form-group">
										<div class="eyecatcher"><hit_limit :settings="{id:'get_board_limits'}" /></div>

										<div class="hit-html-small">{{ $tc('message.board', get_boards() ) }}</div>
									</div>
								</div>

								<router-link  class="hit-btn hit-btn-warning hit-btn-block" :to="{ name: 'boards', params: {lang: $store.getters.lang} }">{{ $t('message.edit', {name: $tc('message.board', get_boards())}) }}</router-link>

							</div>

						</div>

						<div class="hit-col-md-4">
							<div class="hit-panel hit-panel-danger">

								<div class="hit-panel-body hit-text-center hit-text-danger">

									<div class="hit-form-group">
										<div class="eyecatcher">{{ get_votes() }}</div>

										<div class="hit-html-small">{{ $tc('message.feedback', get_votes() ) }}</div>
									</div>
								</div>

								<router-link v-if="get_votes()" class="hit-btn hit-btn-danger hit-btn-block" :to="{ name: 'feedbacks', params: {lang: $store.getters.lang} }">{{ $t('message.edit', {name: $tc('message.feedback', get_votes())}) }}</router-link>

								<div v-if="!get_votes()" class=" hit-btn hit-btn-danger hit-btn-block hit-disabled">
									{{ $t('message.edit', {name: $tc('message.feedback', get_votes())}) }}
								</div>

							</div>

						</div>

						<div class="hit-col-md-4">
							<div class="hit-panel hit-panel-info">

								<div class="hit-panel-body hit-text-center hit-text-info">

									<div class="hit-form-group">
										<div class="eyecatcher"><i class="hit-glyphicon hit-glyphicon-user"></i></div>

										<div class="hit-html-small">{{ $store.getters.user.username }}</div>
									</div>
								</div>

									<router-link class=" hit-btn hit-btn-info hit-btn-block" :to="{ name: 'profile', params: {lang: $store.getters.lang} }">{{ $t('message.edit', {name: $t('message.profile')}) }}</router-link>

							</div>

						</div>
					</div>
				</div>
			</div>
			</div>

				<div class="hit-row">

					<div class="hit-col-md-8">
						<hit_entries />
						<hit_hints />
					</div>

					<div class="hit-col-md-4">
						<hit_unread_chats />
					</div>
				</div>

		</div>

	</hit_login>

</template>

<script>

import hit_stars from '@core/components/assets/hit_stars'
import hit_hints from '@core/components/content/app/dashboard/hints'
import hit_entries from '@core/components/content/app/dashboard/entries'
import hit_unread_chats from '@core/components/content/app/dashboard/unread_chats'

export default{
  name: 'app',
  components: {hit_stars, hit_hints, hit_unread_chats, hit_entries},

  methods: {

    get_boards: function () {
      return Object.keys(this.$store.getters.boards).length
    },
    get_votes: function () {
      return Object.keys(this.$store.getters.votes).length
    }

  },

  metaInfo: function () {
	    return {
	     title: this.$tc('message.dashboard', 1)
	   }
	 },

	 mounted () {
		 this.$store.dispatch('get_user_boards')
		 this.$store.dispatch('get_all_votes')
	 }

}
</script>

<style>

.eyecatcher{
	font-size: 4em;
}
</style>
